import { useState } from 'react'
import { Button, Group, Modal, Text, TextInput } from '@mantine/core'
import { toast } from 'react-toastify'
import agent from '../../api/agent'
import type { FlagTargetType } from '../../models/flag'

export interface ReportContentModalProps {
  opened: boolean
  onClose: () => void
  targetType: FlagTargetType
  targetId: string
  postCommentId?: number
  /** Shown in modal title, e.g. "post", "firearm model". */
  contentLabel?: string
}

export default function ReportContentModal ({
  opened,
  onClose,
  targetType,
  targetId,
  postCommentId,
  contentLabel = 'content'
}: ReportContentModalProps) {
  const [reason, setReason] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleClose = () => {
    setReason('')
    onClose()
  }

  const submit = async () => {
    const r = reason.trim()
    if (!r) {
      toast.error('Please describe the issue.')
      return
    }
    setSubmitting(true)
    try {
      await agent.Flags.submit({
        targetType,
        targetId,
        postCommentId,
        reason: r
      })
      toast.success('Report submitted. Moderators will review it.')
      handleClose()
    } catch {
      /* interceptor */
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={`Report ${contentLabel}`}
      centered
    >
      <Text size="sm" color="dimmed" mb="sm">
        Describe what's wrong. Reports are reviewed by the moderation team. We will review your report and take appropriate action.
      </Text>
      <TextInput
        placeholder="Reason"
        value={reason}
        onChange={(e) => setReason(e.currentTarget.value)}
        mb="md"
      />
      <Group position="right">
        <Button variant="default" onClick={handleClose}>
          Cancel
        </Button>
        <Button color="red" onClick={() => void submit()} loading={submitting}>
          Submit report
        </Button>
      </Group>
    </Modal>
  )
}
